<template>
  <div class="dj-case-page full-page" :style="'background: url(' + currentPageBg.bg + ') no-repeat center; ' + 'background-size: cover'">
    <!--<img class="page-bg" :src="currentPageBg.bg"/>-->
    <div class="page-mask" v-if="(currentGuideIdx === 1 && currentPageBg.idx === 1) || currentGuideIdx === 2 || currentGuideIdx === 3"></div>
    <div class="full-page page-content page-achievement" v-if="currentGuideIdx === 1">
      <div :class="currentPageBg.idx === 1 ? 'element-display': 'element-hide'">
        <div class="page-title">智能过滤机</div>
        <div class="page-sub-title">专业耐酸碱泵浦和精密化学药液过滤机生产商和服务商</div>
        <div class="page-group">
          <div class="group-item left">
            <div class="item-img left">
              <img src="../../../assets/img/case/case-precent-icon-01.png"/>
            </div>
            <div class="item-content">
              <div class="item-title">30%</div>
              <div class="item-sub-title">实时监测，快速排故障，<br/>节省设备故障修复时间</div>
            </div>
          </div>
          <div class="group-item left">
            <div class="item-img left">
              <img src="../../../assets/img/case/case-precent-icon-02.png"/>
            </div>
            <div class="item-content">
              <div class="item-title">20%</div>
              <div class="item-sub-title">预测性维护，<br/>降低异常停机时间</div>
            </div>
          </div>
          <div class="group-item left">
            <div class="item-img left">
              <img src="../../../assets/img/case/case-precent-icon-03.png"/>
            </div>
            <div class="item-content">
              <div class="item-title">40%</div>
              <div class="item-sub-title">用数据针对性维保换件，<br/>备件费用降低</div>
            </div>
          </div>
          <div class="group-item left">
            <div class="item-img left">
              <img src="../../../assets/img/case/case-precent-icon-04.png"/>
            </div>
            <div class="item-content">
              <div class="item-title">5%</div>
              <div class="item-sub-title">数据智能监测，<br/>提升产品附加值</div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="page-carousel glj-page-carousel">
        <div class="carousel-item-block left" v-for="(item, index) in carouselImgList" :key="index">
          <div class="carousel-item" :class="currentPageBg.idx === item.idx ? 'carousel-item-active': ''" @click="choosePageBg(item)">
            <div class="carousel-img-sign" v-if="item.idx === 1">
              <icon class="carousel-img-sign-icon" name="exclamation"></icon>
            </div>
            <div class="carousel-item-mask" :class="currentPageBg.idx === item.idx ? 'carousel-item-mask-active': ''"></div>
            <img class="carousel-img" :src="item.icon"/>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="page-carousel-pad glj-page-carousel-pad">
        <div class="page-carousel-pad-content">
          <div class="carousel-pad-item-block glj-carousel-pad-item-block left" v-for="(item, index) in carouselImgList" :key="index">
            <div class="carousel-pad-item" :class="currentPageBg.idx === item.idx ? 'carousel-pad-item-active': ''" @click="choosePageBg(item)">
              <div class="carousel-img-sign" v-if="item.idx === 1">
                <icon class="carousel-img-sign-icon" name="exclamation"></icon>
              </div>
              <div class="carousel-item-mask" :class="currentPageBg.idx === item.idx ? 'carousel-item-mask-active': ''"></div>
              <img :src="item.icon"/>
              <div class="clear"></div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="carousel-button button-pre" @click="checkPageBefore"><i class="el-icon-arrow-left button-arrow-icon"></i></div>
        <div class="carousel-button button-next" @click="checkPageNext"><i class="el-icon-arrow-right button-arrow-icon"></i></div>
        <div class="clear"></div>
      </div>
    </div>
    <div class="full-page page-content page-problem" v-if="currentGuideIdx === 2">
      <div class="problem-group">
        <div class="problem-item">
          <div class="problem-title">已售设备当前状态一无所知</div>
          <div class="problem-sub-title">设备分布各地，设备动态无法及时了解</div>
        </div>
        <div class="problem-item">
          <div class="problem-title">设备运营数据无法掌控</div>
          <div class="problem-sub-title">设备的能量产耗等关键数据无法监测</div>
        </div>
        <div class="problem-item">
          <div class="problem-title">设备维修保养处于被动状态</div>
          <div class="problem-sub-title">设备状况不能及时诊断分析维护，耗材的损耗信息不能为二次销售提供及时信息</div>
        </div>
        <div class="problem-item">
          <div class="problem-title">设备同质化严重</div>
          <div class="problem-sub-title">行业同质化严重，众厂家价格战白热化，设备销售缺乏竞争力</div>
        </div>
      </div>
    </div>
    <div class="full-page page-content page-solution" v-if="currentGuideIdx === 3">
      <div class="solution-content">
        <div class="solution-diagram">
          <img class="diagram-img" src="../../../assets/img/case/case-solution-diagram-01.png"/>
        </div>
        <div class="solution-feature">
          <div class="feature-title">系统功能</div>
          <div class="feature-group">
            <div class="feature-item left" v-for="(item, index) in featureList" :key="index">
              <img :src="item.icon"/>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../styles/page.scss'
export default {
  name: 'dJingPage',
  props: {
    currentGuideIdx: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      currentPageBg: {
        idx: 1,
        bg: require('../../../assets/img/case/case-page-bg-01.png')
      },
      carouselImgList: [
        {idx: 1, icon: require('../../../assets/img/case/glj/case-glj-page-bg-01.png'), bg: require('../../../assets/img/case/glj/case-glj-page-bg-01.png')},
        {idx: 2, icon: require('../../../assets/img/case/glj/case-glj-page-bg-02.jpg'), bg: require('../../../assets/img/case/glj/case-glj-page-bg-02.jpg')},
        {idx: 3, icon: require('../../../assets/img/case/glj/case-glj-page-bg-03.jpg'), bg: require('../../../assets/img/case/glj/case-glj-page-bg-03.jpg')},
        {idx: 4, icon: require('../../../assets/img/case/glj/case-glj-page-bg-04.jpg'), bg: require('../../../assets/img/case/glj/case-glj-page-bg-04.jpg')},
        {idx: 5, icon: require('../../../assets/img/case/glj/case-glj-page-bg-05.jpg'), bg: require('../../../assets/img/case/glj/case-glj-page-bg-05.jpg')},
        {idx: 6, icon: require('../../../assets/img/case/glj/case-glj-page-bg-06.jpg'), bg: require('../../../assets/img/case/glj/case-glj-page-bg-06.jpg')},
        {idx: 7, icon: require('../../../assets/img/case/glj/case-glj-page-bg-07.jpg'), bg: require('../../../assets/img/case/glj/case-glj-page-bg-07.jpg')},
        {idx: 8, icon: require('../../../assets/img/case/glj/case-glj-page-bg-08.jpg'), bg: require('../../../assets/img/case/glj/case-glj-page-bg-08.jpg')}
      ],
      featureList: [
        {idx: 1, icon: require('../../../assets/img/case/case-feature-01.png')},
        {idx: 2, icon: require('../../../assets/img/case/case-feature-02.png')},
        {idx: 3, icon: require('../../../assets/img/case/case-feature-03.png')},
        {idx: 4, icon: require('../../../assets/img/case/case-feature-04.png')},
        {idx: 5, icon: require('../../../assets/img/case/case-feature-05.png')},
        {idx: 6, icon: require('../../../assets/img/case/case-feature-06.png')},
        {idx: 7, icon: require('../../../assets/img/case/case-feature-07.png')},
        {idx: 8, icon: require('../../../assets/img/case/case-feature-08.png')},
        {idx: 9, icon: require('../../../assets/img/case/case-feature-09.png')},
        {idx: 10, icon: require('../../../assets/img/case/case-feature-10.png')},
        {idx: 11, icon: require('../../../assets/img/case/case-feature-11.png')},
        {idx: 12, icon: require('../../../assets/img/case/case-feature-12.png')},
        {idx: 13, icon: require('../../../assets/img/case/case-feature-13.png')},
        {idx: 14, icon: require('../../../assets/img/case/case-feature-14.png')},
        {idx: 15, icon: require('../../../assets/img/case/case-feature-15.png')},
        {idx: 16, icon: require('../../../assets/img/case/case-feature-16.png')}
      ]
    }
  },
  methods: {
    choosePageBg (data) {
      this.currentPageBg.idx = data.idx
      this.currentPageBg.bg = data.bg
    },
    // 图片切换，上一张
    checkPageBefore () {
      let obj = this.carouselImgList[0]
      for (let i = 0; i < this.carouselImgList.length - 1; i++) {
        this.carouselImgList[i] = this.carouselImgList[i + 1]
        this.$set(this.carouselImgList, i, this.carouselImgList[i + 1])
      }
      this.$set(this.carouselImgList, this.carouselImgList.length - 1, obj)
    },
    // 图片切换，下一张
    checkPageNext () {
      let obj = this.carouselImgList[this.carouselImgList.length - 1]
      for (let i = this.carouselImgList.length - 1; i >= 1; i--) {
        this.$set(this.carouselImgList, i, this.carouselImgList[i - 1])
      }
      this.$set(this.carouselImgList, 0, obj)
    }
  }
}
</script>

<style scoped>
  .glj-page-carousel {
    display: none;
  }
  .glj-page-carousel-pad {
    display: block;
    margin-top: 146px;
  }
  .glj-carousel-pad-item-block {
    width: 16.6%;
  }
  @media all and (max-width: 1430px) {
    .glj-page-carousel-pad {
      margin-top: 20px;
    }
    .glj-carousel-pad-item-block {
      width: 25%;
    }
  }
  @media all and (max-width: 900px) {
    .glj-carousel-pad-item-block {
      width: 33.3%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/case/components/GLvJiPage.vue